import invoke from 'lodash/invoke';

export const enableMobileXExitPrompt = () => {
  setMobileXExitPrompt(true);
};

export const disableMobileXExitPrompt = () => {
  setMobileXExitPrompt(false);
};

const setMobileXExitPrompt = (param, MobileBridge = global.MobileBridge) => {
  invoke(MobileBridge, 'exitPrompt.isEnabled', param);
};

export const responseReceived = (statusCode = '500', MobileBridge = global.MobileBridge) => {
  invoke(MobileBridge, 'session.responseReceived', `${statusCode}`);
};
